/**
 * @file LandingSports/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

export const OVERRIDE_SLIDER_VIDEOS = {
    "sports/paralympics": "sports/paralympics/strip",
    "sports/calgarystampede": "sports/calgarystampede/strip",
};

export const HIDE_SLIDER_ON_SECTION = {
    "sports/soccer/worldcup": true,
    "sports/soccer": true,
    "sports/soccer/mls": true,
    "sports/soccer/cpl": true,
};

export const HIDDEN_PAGE_HEADING = {
    sports: true,
};
